import { type FC } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import { useShopfrontDispatch, useShopfrontSelector } from "../../_Bootstrap/hooks";
import { LAYOUT_TOGGLE_MENU } from "../../Actions/General/LayoutActions";
import { fireEventType } from "../../Utilities/Generic/ActionsHelper";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

export const Menu: FC = () => {
    const dispatch = useShopfrontDispatch();

    const open = useShopfrontSelector(state => state.layout.menu.open);

    let icon: IconProp = "bars";

    if(open) {
        icon = "times";
    }

    return (
        <div
            className="header-item"
            data-testid="sh-menu"
        >
            <FontAwesomeLight
                icon={icon}
                className="cursor-pointer text-dark-50 text-2xl"
                onClick={() => {
                    dispatch(fireEventType(LAYOUT_TOGGLE_MENU));
                }}
            />
        </div>
    );
};
